import React from 'react'
import { SGPageTemplateProductCollection } from '../../../../../../src/types/page-templates'
import { ProductDeck } from '../../../../../../src/shared/hub-components/product-deck'
import { ModuleProps } from '../../types'

export default function SGPageTemplateContentCollectionProductReelModule({
  module,
}: ModuleProps<SGPageTemplateProductCollection>): JSX.Element | null {
  if (module.items.length === 0) {
    return null
  }

  return (
    <ProductDeck
      title={module.title || ''}
      text={module.shortDescription ?? undefined}
      products={module.items}
    />
  )
}
